﻿$(document).ready(function () {
    var processSearch = function () {
        var searchString = $('.search-input').val();

        if (searchString) {
            window.location.href = "/search/?searchtext=" + encodeURIComponent(decodeURIComponent(searchString));
        }
    }

    $('.search-input').keypress(function (e) {
        if (e.which == 13) {
            e.preventDefault();
            processSearch();
        }
    });

    $('.input-container .fa-search').click(function () {
        processSearch();
    });

    //Click outside: anywhere on the screen but the searchbar
    $("#global-banner-wrapper").bind("clickoutside", function (event) {
        var windowsize = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (windowsize > 798) {
            var target = $(this),
                targetSlide = $($(this).attr('href'));

            target.toggleClass('active');
            $('.global-nav-search-trigger').not($(this)).removeClass('active');
            targetSlide.toggleClass('active');
            if (targetSlide.is('.active')) {
                targetSlide.focus();
            }
            $('.global-nav-search-toggle').not(targetSlide).removeClass('active');
        }
        return false;
    });

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        var countrycodes = "1";
        var delimiters = "-|\\.|—|–|&nbsp;";
        var phonedef = "\\+?(?:(?:(?:" + countrycodes + ")(?:\\s|" + delimiters + ")?)?\\(?[2-9]\\d{2}\\)?(?:\\s|" + delimiters + ")?[2-9]\\d{2}(?:" + delimiters + ")?[0-9a-z]{4})";
        var spechars = new RegExp("([- \(\)\.:]|\\s|" + delimiters + ")", "gi"); //Special characters to be removed from the link
        var phonereg = new RegExp("((^|[^0-9])(href=[\"']tel:)?((?:" + phonedef + ")[\"'][^>]*?>)?(" + phonedef + ")($|[^0-9]))", "gi");

        var replacePhoneNumbers = function (oldhtml) {
            if (oldhtml !== undefined) {
                var newhtml = oldhtml.replace(/href=['"]callto:/gi, 'href="tel:');
                newhtml = newhtml.replace(phonereg, function ($0, $1, $2, $3, $4, $5, $6) {
                    if ($3) return $1;
                    else if ($4) return $2 + $4 + $5 + $6;
                    else return $2 + "<a href='tel:" + $5.replace(spechars, "") + "'>" + $5 + "</a>" + $6;
                });
                return newhtml;
            }
        };

        $(".ve-phone").each(function () {
            $(this).html(replacePhoneNumbers($(this).html()));
        });
    }

    // #region AHP

    var htmlConstants = {
        spanCaretHtml: ' <span class="fa fa-angle-down"></span>'
    };

    var classConstants = {
        openClass: 'open',
        arrowUp: 'fa fa-angle-up',
        arrowDown: 'fa fa-angle-down'
    };

    var tagConstants = {
        buttonTag: 'button'
    };

    var sc = {
        hiddenSelectedCountry: 'input#hdnSelectedCountry',
        hiddenSelectedInvestorType: 'input#hdnSelectedAudience',
        hiddenCountryUrl: 'input#hdnCountryUrl',
        dataUrlSelector: 'input#hdnDataUrl',
        countrySelectClick: 'div.btn-group.countries ul.dropdown-menu li a',
        countryButton: 'div.btn-group.countries button',
        investorTypeButton: 'div.btn-group.investortype button',
        goButton: 'div.btn-group.go a',
        investorTypeSelectClick: 'div.btn-group.investortype ul.dropdown-menu li a',
        investorTypeDropdown: 'ul.dropdown-menu.investortype',
        websiteLangDropdown: 'div#site-lang-dropdown',
        websiteLangDropdownList: 'div#site-lang-dropdown ul',
        ahpLangDropdown: 'div#ahp-lang-dropdown',
        ahpLangDropdownList: 'div#ahp-lang-dropdown ul',
        ahpLangText: 'div#ahp-lang-dropdown > a',
        ahpLangDropdownClick: 'div#ahp-lang-dropdown ul li a',
        ahpSelector: '.global-nav-slidedown-trigger',
        hiddenLanguage: 'input#hdnLanguage',
        selectCountryText: '#select-country-text',
        selectInvestorTypeText: '#select-investor-text',
        disclaimerHeader: '#disclaimer-header',
        hiddenCurrentLanguage: '#hdnCurrentLanguage',
        disclaimerSection: '#disclaimer-section',
        ahpSearchButton: '.global-nav-search-trigger',
        currentCountryName: '#hdnCurrentCountryName'
    };

    var actionMethods = {
        getInvestorAndLanguages: 'getinvestorandlanguages',
        getTranslations: 'gettranslations',
        getDisclaimer: 'getdisclaimer'
    };

    pushGtmEvent = function (event, action) {
        if (typeof dataLayer !== "undefined" && typeof dataLayer.push !== "undefined") {
            dataLayer.push({
                'event': event,
                'eventAction': action
            });
        }
    };

    pushGtmMicrositeClickEvent = function ($obj) {
        if (($obj instanceof jQuery) === false) {
            $obj = $($obj);
        }

        var microsite = $obj.data('microsite');

        if (microsite) {
            pushGtmEvent('ahp-selector-microsite-click-event', microsite);
        }
    };

    acceptClickEvent = function (url, target) {
        var decodedUrl = decodeURIComponent(url);
        if (target === '') {
            target = '_self';
        }
        window.location.target = target;
        var parentUrl = window.location.toString();
        if (parentUrl.match('#')) {
            decodedUrl = decodedUrl + '#' + parentUrl.split('#')[1];
        }
        window.location.href = decodeURIComponent(decodedUrl);
        return false;
    };

    declineClickEvent = function (url, target) {
        if (url === "/") {
            window.location.reload();
        }
        else {
            var decodedUrl = decodeURIComponent(url);
            if (target === '') {
                target = '_self';
            }
            window.location.target = target;
            var parentUrl = window.location.toString();
            if (parentUrl.match('#')) {
                decodedUrl = decodedUrl + '#' + parentUrl.split('#')[1];
            }
            window.location.href = decodeURIComponent(decodedUrl);
        }
        return false;
    };

    disableElement = function (id) {
        $(id).addClass('disabled');
    };

    enableElement = function (id) {
        $(id).removeClass('disabled');
    };

    clickInit = function (obj, e) {
        var $div = obj.parent().parent().parent();
        var $btn = $div.find(tagConstants.buttonTag);
        $btn.html(obj.text() + htmlConstants.spanCaretHtml);
        $div.removeClass(classConstants.openClass);
        e.preventDefault();
    };

    getData = function (action, param1, param2, param3, param4, param5, param6, param7) {
        return $.ajax({
            type: "GET",
            url: $(sc.dataUrlSelector).val(),
            data: {
                "op": action, "param1": param1, "param2": param2, "param3": param3, "param4": param4, "param5": param5, "param6": param6, "param7": param7
            },
            cache: false,
            async: false
        });
    };

    changeAhpLanguage = function (lang) {
        var target = lang;
        $(sc.ahpLangText).html(target.html() + '<i class="fa fa-angle-up"></i>');
        var oldLanguageIso = $(sc.hiddenLanguage).val();
        $(sc.hiddenLanguage).val(target.data('id'));

        var audienceType = $(sc.hiddenSelectedInvestorType).val();

        var countryIso = $(sc.hiddenSelectedCountry).val();
        var countryName = '';
        var countryUrl = $(sc.hiddenCountryUrl).val();
        if ($(sc.disclaimerHeader).length > 1) {
            audienceType = $(sc.disclaimerHeader).data('audience');
            countryIso = $(sc.disclaimerHeader).data('countryiso');
            countryName = $(sc.disclaimerHeader).data('countryname');
            countryUrl = $(sc.disclaimerHeader).data('accepturl');
        }
        else {
            audienceType = $(sc.hiddenSelectedInvestorType).val();
            countryIso = $(sc.hiddenSelectedCountry).val();
            countryName = $(sc.currentCountryName).val();
            countryUrl = $(sc.hiddenCountryUrl).val();
        }
        var defaultDeepLinkSession = '';
        if ($('body').hasClass('disclaimer-deeplink')) {
            defaultDeepLinkSession = 'true';
        }
        var translations = getData(actionMethods.getTranslations, target.data('id'), audienceType, countryIso, countryName, countryUrl, oldLanguageIso, defaultDeepLinkSession);
        translations.done(function (translation) {
            $.each(translation.List, function (index, value) {
                $('.content-item-t').each(function () {
                    var regex = new RegExp(value.Text, 'g');
                    var translatedHtml = $(this).html().replace(regex, value.TranslatedText);
                    $(this).html(translatedHtml);
                });
            });
            var contentHtml = '';
            if (translation.Text !== null && translation.Text !== '') {
                contentHtml = '<h1 id="disclaimer-header">' + translation.Header + '</h1>' +
                    '<div class="disclaimer-text">' + translation.Text + '</div>' +
                    '<div class="disclaimer-button">' +
                    '<a id="btnAgree" class="btn btn-primary agree" data-ve-gtm="ahp-disclaimer-agree" onclick=acceptClickEvent("' + translation.AcceptUrl + '")>' + translation.AgreeText + '</a>' +
                    '<a class="btn btn-primary decline" data-ve-gtm="ahp-disclaimer-decline" onclick=declineClickEvent("' + translation.DeclineUrl + '")>' + translation.DeclineText + '</a>' +
                    '</div>';
            }
            else {
                contentHtml = '<div class="disclaimer-button">' +
                    '<a id="btnAgree" class="btn btn-primary agree" data-ve-gtm="ahp-disclaimer-agree" onclick=acceptClickEvent("' + translation.AcceptUrl + '")>Go</a>' +
                    '</div>';
            }
            $(sc.disclaimerSection).html(contentHtml);
        });
    };

    investorTypeSelection = function (thisaction, event, action, investorType, selectedCountry, returnUrl, currentUrl) {
        clickInit(thisaction, event);
        $(sc.hiddenSelectedInvestorType).val(thisaction.data('id'));
        console.log($(sc.currentCountryName).val());
        var disclaimerJson = getData(action, $(sc.hiddenSelectedInvestorType).val(), selectedCountry, returnUrl, currentUrl, $(sc.hiddenLanguage).val(), '', $(sc.currentCountryName).val());
        disclaimerJson.done(function (disclaimer) {
            var contentHtml = '';
            if (disclaimer.Text !== null && disclaimer.Text !== '') {
                contentHtml = '<h1 id="disclaimer-header">' + disclaimer.Header + '</h1>' +
                    '<div class="disclaimer-text">' + disclaimer.Text + '</div>';
            }
            contentHtml = contentHtml + '<div class="disclaimer-button">' +
                '<a id="btnAgree" class="btn btn-primary agree" data-ve-gtm="ahp-disclaimer-agree" onclick=acceptClickEvent("' + disclaimer.AcceptUrl + '")>' + disclaimer.AgreeText + '</a>' +
                '<a class="btn btn-primary decline" data-ve-gtm="ahp-disclaimer-decline" onclick=declineClickEvent("' + disclaimer.DeclineUrl + '")>' + disclaimer.DeclineText + '</a>' +
                '</div>';
            $(sc.disclaimerSection).html(contentHtml);
        }).always(function () {
            $(".global-nav-slidedown, .global-nav-slidedown-internal").removeClass("overflow-visible"); //make sure the overflow class is removed when the dropdown is closed.
        });

        return false;
    };

    $(sc.countrySelectClick)
        .click(function (e) {
            clickInit($(this), e);
            var blockId = $(this).data('blockId');
            var currentUrl = encodeURIComponent(window.location.pathname + window.location.search);
            $(sc.hiddenSelectedCountry).val($(this).data('id'));
            $(sc.hiddenLanguage).val('');
            $(sc.currentCountryName).val($(this).data('name'));
            $(sc.disclaimerSection).html('');

            var $div = $(this).parent().parent().parent();
            var $btn = $div.find(tagConstants.buttonTag);
            $btn.attr('class', 'btn btn-default dropdown-toggle global-nav-flag country-' + $(this).text().toLowerCase().replace(/\s/g, '-') + ' content-item-t');

            var jsonData = getData(actionMethods.getInvestorAndLanguages, blockId, $(this).data('id'), currentUrl);
            jsonData.done(function (json) {
                if (json.InvestorType !== null) {
                    var investorHtml = '';
                    $.each(json.InvestorType, function (key, value) {
                        investorHtml += '<li><a data-id="' + key + '" class="content-item-t">' + value + '</a></li>';
                    });
                    $(sc.investorTypeDropdown).html(investorHtml);
                }
                $(sc.investorTypeButton).html('Select Investor Type <span class="fa fa-angle-down"></span>');
                enableElement(sc.investorTypeButton);
                disableElement(sc.goButton);
                $(sc.investorTypeSelectClick)
                    .click(function (e) {
                        investorTypeSelection($(this), e, actionMethods.getDisclaimer, $(sc.hiddenSelectedInvestorType).val(), $(sc.hiddenSelectedCountry).val(), '', currentUrl);
                    });

                if (json.Languages !== null) {
                    var languageHtml = '';

                    var length = 0;
                    for (var key in json.Languages) {
                        length++;
                    }

                    if (length > 1) {
                        $.each(json.Languages, function (key, value) {
                            languageHtml += '<li><a data-id="' + key + '">' + value + '</a></li>';
                        });
                        $(sc.ahpLangDropdownList).html(languageHtml);
                        $(sc.ahpLangText).html($(sc.hiddenCurrentLanguage).val() + ' <i class="fa fa-angle-down"></i>');
                    }
                    else {
                        $(sc.ahpLangText).html($(sc.hiddenCurrentLanguage).val());
                    }
                }

                $(sc.ahpLangDropdownClick)
                    .click(function (e) {
                        changeAhpLanguage($(this));
                    });
            }).always(function () {
                $(".global-nav-slidedown, .global-nav-slidedown-internal").removeClass("overflow-visible"); //make sure the overflow class is removed when the dropdown is closed.
            });

            return false;
        });

    $(sc.investorTypeSelectClick)
        .click(function (e) {
            investorTypeSelection($(this), e, actionMethods.getDisclaimer, $(sc.hiddenSelectedInvestorType).val(), $(sc.hiddenSelectedCountry).val(), encodeURIComponent(window.location.pathname + window.location.search), '');
        });

    $(sc.goButton)
        .click(function (e) {
            var className = $(this).attr('class');
            if (className.indexOf("disabled") >= 0) {
                return false;
            }
            var url = decodeURIComponent($(sc.hiddenCountryUrl).val());
            window.location.href = decodeURIComponent(url);
        });

    $(sc.ahpLangDropdownClick)
        .click(function (e) {
            changeAhpLanguage($(this));
        });

    $(sc.ahpLangDropdown)
        .click(function (e) {
            var targetAnchor = $(this).find('a#dropdownMenuButton');
            if ($(this).is('.open')) {
                targetAnchor.find('i').removeClass(classConstants.arrowUp);
                targetAnchor.find('i').addClass(classConstants.arrowDown);
            }
            else {
                targetAnchor.find('i').removeClass(classConstants.arrowDown);
                targetAnchor.find('i').addClass(classConstants.arrowUp);
            }
            $(this).find('ul li').each(function (i) {
                $(this).show();
            });
            var elemToHide = $(this).find('ul').find('li').find('a:contains("' + $.trim(targetAnchor.text()) + '")');
            elemToHide.parent().hide();
        });

    $(sc.ahpSelector).click(function () {

        var target = $(this),
            targetSlide = $($(this).attr('href'));

        target.toggleClass('active');

        targetSlide.toggleClass('active');
        if (targetSlide.is('.active')) {
            targetSlide.focus();
            $(sc.ahpLangDropdown).show();
            $(sc.websiteLangDropdown).hide();
            $('#global-nav-btn-search').css({ 'visibility':'hidden' });
            //target.find('i').removeClass(classConstants.arrowDown);
            //target.find('i').addClass(classConstants.arrowUp);
        }
        else {
            $(sc.ahpLangDropdown).hide();
            $(sc.websiteLangDropdown).show();
            $('#global-nav-btn-search').css({ 'visibility': 'visible' });
            //target.find('i').removeClass(classConstants.arrowUp);
            //target.find('i').addClass(classConstants.arrowDown);
        }

        $('.global-nav-toggle').not(targetSlide).removeClass('active');

        var id = $(this).attr('id');
        if (id !== undefined && id === 'global-nav-content') {
            $(window).scrollTop(0);
            if (!targetSlide.is('.active')) {
                targetSlide.addClass('active');
            }
        }

        return false;
    });

    $(sc.ahpSearchButton).click(function () {
        //var target = $(this),
        //    targetSlide = $($(this).attr('href'));

        //target.toggleClass('active');

        //targetSlide.toggleClass('active');
        //if (targetSlide.is('.active')) {
        //    targetSlide.focus();
        //}
        //$('.global-nav-search-toggle').not(targetSlide).removeClass('active');
        //return false;
        $('.header-search-overlay').addClass('active');
        $('body, .wrapper, footer').addClass('blur');
    });

    $('.close-btn-container').click(function () {
        $('.header-search-overlay').removeClass('active');
        $('body, .wrapper, footer').removeClass('blur');
    });

    $('.header-search-overlay .search-input').keyup(function () {
        if ($(this).val().length > 0) {
            $('.header-search-overlay .input-placeholder').addClass('active');
        } else {
            $('.header-search-overlay .input-placeholder').removeClass('active');
        }
    });

    if ($(sc.ahpSelector).is('.active')) {
        $(sc.ahpLangDropdown).show();
        $(sc.websiteLangDropdown).hide();
    }

    $(sc.countryButton)
        .click(function () {
            if ($(this).parent().is('.open')) {
                $(this).find('span').attr('class', 'fa fa-angle-down');
            }
            else {
                $(this).find('span').attr('class', 'fa fa-angle-up');
            }
        });

    $(sc.investorTypeButton)
        .click(function () {
            if ($(this).parent().is('.open')) {
                $(this).find('span').attr('class', 'fa fa-angle-down');
            }
            else {
                $(this).find('span').attr('class', 'fa fa-angle-up');
            }
        });

    // #endregion


    // #region AHP Mobile

    $('#ahpMobileClick').click(function () {
        $('.menu-mobile > ul').toggleClass('open');
        $('.close-nav-b').toggleClass('close-nav');
        $('.push-right').toggleClass('close-body');
        $('.menu-mobile').toggleClass('js-ready');
        $('.mobile-push').toggleClass('push-right');

        $('#mobile').hide();
        $('.mainWrapper').hide();
        $('.wrapper').css({ 'position': 'fixed' });
        $('#ahpMobile').show();
        setTimeout(function () { $('body').removeClass('no-overflow') }, 1000);
        $('body').css({ 'display': 'none' });
        setTimeout(function () { $('body').css({ 'display': 'block' }) }, 100);
    });

    $('#closeAhpModal').click(function () {
        $('.menu-mobile > ul').toggleClass('open');
        $('.close-nav-b').toggleClass('close-nav');
        $('.push-right').toggleClass('close-body');
        $('.menu-mobile').toggleClass('js-ready');
        $('.mobile-push').toggleClass('push-right');

        $('#mobile').show();
        $('.mainWrapper').show();
        $('.wrapper').css({ 'position': 'relative' });
        $('#ahpMobile').hide();

        var closeAhpEvent = document.createEvent('Event');

        closeAhpEvent.initEvent('closeAhp', true, true);

        window.dispatchEvent(closeAhpEvent);

        $('.global-nav-toggle').removeClass('active');
    });

    $(window).resize(function () {
        if ($(window).width() < 992) {
            $('.header-search-overlay').removeClass('active');
            $('body, .wrapper, footer').removeClass('blur');
        }
    });
    // #endregion

    // #AddOVerflowClass - Add a class when country and investor dropdown are open to enable them to overflow out of the ahp block.
    $(".global-nav-slidedown .btn-group").on('show.bs.dropdown hidden.bs.dropdown', function (e) { /* to force overflow when dropdown is opened, else dropdown will not be visible. */
        $(".global-nav-slidedown, .global-nav-slidedown-internal").toggleClass("overflow-visible");
    })
    //
});

function updatePageVistCountOnLocalStorage() {
    function getLocalStorageOrCookie(name) {
        return localStorage.getItem(name) ?? getCookie(name);
    }

    function setLocalStorageAndCookie(name, value, cookieExpiresIn){
        if(!cookieExpiresIn) {
            cookieExpiresIn = 365;
        }

        try {
            localStorage.setItem(name, value);
        }
        catch (e) {
            console.error("Error setting localStorage item:", e);
        }
        
        setCookie(name, value, cookieExpiresIn)
    }

    function getCookie(name) {
        var value = "; " + decodeURIComponent(document.cookie);
        var parts = value.split("; " + name + "=");
        if (parts.length === 2) return parts.pop().split(";").shift();
    }

    function setCookie(name, value, expiresIn) {
        var currentDate = new Date();
        currentDate.setTime(currentDate.getTime() + (expiresIn * 24 * 60 * 60 * 1000));
        var expiresIn = "expires=" + currentDate.toUTCString();
        document.cookie = name + "=" + value + ";" + expiresIn + ";path=/";
    }

    var pageVisitCount = getLocalStorageOrCookie("ve-PageVisitCount-au");
    var sessionCount = sessionStorage.getItem("ve-PageVisitCount-au")
    if (pageVisitCount) {
        pageVisitCount = parseInt(pageVisitCount) + 1;
    } else {
        //if gateway modal is open, ignore the page visit
        const gatewayModal = document.getElementById("gateway-modal") ?? document.getElementById("slidedown-country");
        if (gatewayModal && (gatewayModal.classList.contains("show") || gatewayModal.classList.contains("active"))) return;
        pageVisitCount = 1;
    }

    setLocalStorageAndCookie("ve-PageVisitCount-au", pageVisitCount, 365);

    //if gateway modal is open, ignore the page visit
    const gatewayModal = document.getElementById("gateway-modal") ?? document.getElementById("slidedown-country");
    const searchParams = new URLSearchParams(window.location.search);
    const hasDisclaimerParam = searchParams.get("disclaimer");
    if (!hasDisclaimerParam && gatewayModal && (gatewayModal.classList.contains("show") || gatewayModal.classList.contains("active"))) return;

    if (sessionCount) {
        sessionCount = parseInt(sessionCount) + 1;
    } else {
        sessionCount = 0;
    }
        sessionStorage.setItem("ve-PageVisitCount-au", sessionCount);
    }

window.addEventListener("DOMContentLoaded", updatePageVistCountOnLocalStorage);

const initFundMenuAssetClass = options => {
    try {
        options = options || {};

        if (options.assetClasses) {
            let assetClasses = options.assetClasses.split('|');

            assetClasses.forEach(assetClass => {
                assetClass = assetClass.toLowerCase().replaceAll(' ', '.');

                $(`.title-part.${assetClass}`).hover(() => {
                    $('.title-part, .fund-section').removeClass('selected');
                    $(`.title-part.${assetClass}, .fund-section.${assetClass}`).addClass('selected');
                });
            });
        }
    } catch (e) {
        return null;
    }
}

const wisepopups = () => {
    (function (w, i, s, e) { window[w] = window[w] || function () { (window[w].q = window[w].q || []).push(arguments) }; window[w].l = Date.now(); s = document.createElement('script'); e = document.getElementsByTagName('script')[0]; s.defer = 0; s.src = i; e.parentNode.insertBefore(s, e) })('wisepops', 'https://wisepops.net/loader.js?v=2&h=UeUeSMuJ8u');
}

window.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        let assetClasses = $('#fund-menu-asset-classes').val();
        initFundMenuAssetClass({ assetClasses: assetClasses });
        wisepopups();
    });
});